import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
/* Styles */
import styled, { createGlobalStyle } from 'styled-components'
import { spacing } from '@material-ui/system'
import { CssBaseline, Paper as MuiPaper, withWidth } from '@material-ui/core'
/* Base */
import Header from '../components/Header'
/* Helpers */
import LoadingScreen from 'pages/LoadingScreen'

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${props => props.theme.body.background};
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
`

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

const Paper = styled(MuiPaper)(spacing)

const MainContent = styled(Paper)`
  flex: 1;
  background: ${props => props.theme.body.background};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`

const Dashboard = ({ children, width, location }) => {
  const { user } = useSelector(({ registrationReducer }) => registrationReducer)

  if (!user || isEmpty(user)) {
    return <LoadingScreen />
  }

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <AppContent>
        <Header location={location} />
        <MainContent location={location} p={5}>
          {children}
        </MainContent>
      </AppContent>
    </Root>
  )
}

Dashboard.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
  width: PropTypes.string,
}

export default withWidth()(Dashboard)
